
import {Component, Prop, Vue } from "vue-property-decorator";
import {Nutritions} from "@/models/Recipes/Nutritions";

import {round} from "@/utils/Helpers";
import {NutrientType} from "@/models/Ingredient/NutrientType";
import VTrialMasker from "@/components/vTrialMasker.vue";
import LockIcon from "@/components/icons/LockIcon.vue";

@Component({
  components: {LockIcon, VTrialMasker},
  methods: {
    utilsRound: round
  }
})
export default class vNutritionLabelCanada extends Vue {
  @Prop() nutrition!: Nutritions;
  @Prop({ default: true }) showRoundedDv!: boolean;

  // Nutrition Facts Reactive Values
  get servingWeight() {
    return round(
      this.showRoundedDv
        ? this.nutrition.roundedWeightPerServing
        : this.nutrition.weightPerServing,
      2
    );
  }

  get calories() {
    return this.getNutrientDelegate(NutrientType.Energy, this.showRoundedDv);
  }

  get fat() {
    return this.getNutrientDelegate(NutrientType.Fat, this.showRoundedDv);
  }

  get fatDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Fat);
  }

  get saturatedFat() {
    return this.getNutrientDelegate(NutrientType.SaturatedFattyAcids, this.showRoundedDv);
  }

  get transFat() {
    return this.getNutrientDelegate(NutrientType.TransFattyAcids, this.showRoundedDv);
  }

  get saturatedAndTransDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.SaturatedFattyAcids, NutrientType.TransFattyAcids);
  }

  get carbohydrates() {
    return this.getNutrientDelegate(NutrientType.Carbohydrate, this.showRoundedDv);
  }

  get fibre() {
    return this.getNutrientDelegate(NutrientType.Fibre, this.showRoundedDv);
  }

  get fibreDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Fibre);
  }

  get sugars() {
    return this.getNutrientDelegate(NutrientType.Sugars, this.showRoundedDv);
  }

  get sugarsDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Sugars);
  }

  get protein() {
    return this.getNutrientDelegate(NutrientType.Protein, this.showRoundedDv);
  }

  get cholesterol() {
    return this.getNutrientDelegate(NutrientType.Cholesterol, this.showRoundedDv);
  }

  get sodium() {
    return this.getNutrientDelegate(NutrientType.Sodium, this.showRoundedDv);
  }

  get sodiumDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Sodium);
  }

  get potassium() {
    return this.getNutrientDelegate(NutrientType.Potassium, this.showRoundedDv);
  }

  get potassiumDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Potassium);
  }

  get calcium() {
    return this.getNutrientDelegate(NutrientType.Calcium, this.showRoundedDv);
  }

  get calciumDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Calcium);
  }

  get iron() {
    return this.getNutrientDelegate(NutrientType.Iron, this.showRoundedDv);
  }

  get ironDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.Iron);
  }

  get vitaminD() {
    return this.getNutrientDelegate(NutrientType.VitaminD, this.showRoundedDv);
  }

  get vitaminDDv() {
    return this.getNutrientDvDelegate(this.showRoundedDv, NutrientType.VitaminD);
  }

  NutrientType = NutrientType;
  get isTrial() {
    return this.$store.getters.getUserDetails.isTrial;
  }

  print() {
    this.sendToPrint();
  }

  sendToPrint() {
    window.print();
  }

  getNutrientDelegate(nutrientType: NutrientType, showRoundedDv: boolean) {
    return showRoundedDv
      ? round(this.nutrition.getRoundedValue(nutrientType), 2)
      : round(this.nutrition.getExactValue(nutrientType), 2);
  }

  getNutrientDvDelegate(showRoundedDv: boolean,...nutrientType: NutrientType[]) {
    return showRoundedDv
      ? round(this.nutrition.getRoundedDailyValue(...nutrientType), 0)
      : round(this.nutrition.getExactDailyValue(...nutrientType), 2);
  }
}
